import React from "react";
import { REQUEST_STATUS_OPTIONS } from "./nocStatusConstants";

interface RequestStatusFilterProps {
  value: string;
  onChange: (value: string) => void;
}

const RequestStatusFilter: React.FC<RequestStatusFilterProps> = ({ value, onChange }) => {
  return (
    <select
      className="form-select form-select-sm"
      style={{ width: "180px", height: "31px", padding: "0 10px" }}
      value={value}
      onChange={(e) => onChange(e.target.value)}
    >
      <option value="">All Statuses</option>
      {REQUEST_STATUS_OPTIONS.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
};

export default RequestStatusFilter;
